import { ethers } from 'ethers';
import { RPC_URL, XTREMEVERSE_ERC20_ADDRESS } from "../constants";

const UNISWAP_V3_QUOTER_V2_ADDRESS = '0x61fFE014bA17989E743c5F6cB21bF9697530B21e';
const UNISWAP_V3_FACTORY_ADDRESS = '0x1F98431c8aD98523631AE4a59f267346ea31F984';
const WETH_ADDRESS = '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2';
const USDC_ADDRESS = '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48';

const QUOTER_V2_ABI = [
  'function quoteExactInputSingle(tuple(address tokenIn, address tokenOut, uint256 amountIn, uint24 fee, uint160 sqrtPriceLimitX96) params) external returns (uint256 amountOut, uint160 sqrtPriceX96After, uint32 initializedTicksCrossed, uint256 gasEstimate)'
];

export async function getUniswapQuote(
  tokenIn: string,
  tokenOut: string,
  amountIn: string,
  fee: number
) {
  const provider = new ethers.JsonRpcProvider(RPC_URL);
  const quoterContract = new ethers.Contract(
    UNISWAP_V3_QUOTER_V2_ADDRESS, QUOTER_V2_ABI, provider);
  
  try {
    const params = {
      tokenIn,
      tokenOut,
      fee,
      amountIn,
      sqrtPriceLimitX96: 0
    };


    const [amountOut] = await quoterContract.quoteExactInputSingle.staticCall(params);
    
    return amountOut;
  } catch (error) {
    console.error('Error getting quote:', error);
    if (error instanceof Error) {
      console.error('Error message:', error.message);
    }
    throw error;
  }
}
const FACTORY_ABI = [
  'function getPool(address tokenA, address tokenB, uint24 fee) external view returns (address pool)'
];

async function checkPoolExistence(provider: ethers.Provider, tokenA: string, tokenB: string, fee: number): Promise<boolean> {
  const factory = new ethers.Contract(UNISWAP_V3_FACTORY_ADDRESS, FACTORY_ABI, provider);
  const poolAddress = await factory.getPool(tokenA, tokenB, fee);
  return poolAddress !== ethers.ZeroAddress;
}
export async function getUniswapQuoteForXtreme() {
  const provider = new ethers.JsonRpcProvider(RPC_URL);

  const feeTiers = [100, 500, 3000, 10000]; // All possible fee tiers

  try {
    // Find a valid pool for XTREMEVERSE/WETH
    let xtremeWethFee;
    for (let fee of feeTiers) {
      if (await checkPoolExistence(provider, XTREMEVERSE_ERC20_ADDRESS, WETH_ADDRESS, fee)) {
        
        xtremeWethFee = fee;
        break;
      }
    }

    if (!xtremeWethFee) {
      throw new Error('No valid pool found for XTREMEVERSE/WETH');
    }

    // Get quote from XTREMEVERSE to WETH
    let xtremeToWethAmount = await getUniswapQuote(
      XTREMEVERSE_ERC20_ADDRESS,
      WETH_ADDRESS,
      ethers.parseEther('1').toString(), // 1 XTREMEVERSE token
      xtremeWethFee
    );
    // Get quote from WETH to USDC (assuming 0.05% fee pool for WETH/USDC)
    let wethToUsdcAmount = await getUniswapQuote(
      WETH_ADDRESS,
      USDC_ADDRESS,
      xtremeToWethAmount.toString(),
      500
    );

    
    let usdcAmount = ethers.formatUnits(wethToUsdcAmount, 6);
    // convert to number
    return Number(usdcAmount);
  } catch (error) {
    console.error('Error in getUniswapQuoteForXtreme:', error);
    throw error;
  }
}
